export default __webpack_public_path__ + "assets/6d7dd2292a87ba1129de3b653e0b2da0.jpeg";